import React from "react";
import MyRouts from "./routers/routes";
import { initializeApp } from "firebase/app";

function App() {
  return (
    <div>
      <MyRouts />
    </div>
  );
}
const firebaseConfig = {
  apiKey: "AIzaSyDXwXFvK3rpQ4c-P2WnwP1bA-IKMa-IDa4",
  authDomain: "flip-or-tell.firebaseapp.com",
  databaseURL: "https://flip-or-tell-default-rtdb.firebaseio.com",
  projectId: "flip-or-tell",
  storageBucket: "flip-or-tell.firebasestorage.app",
  messagingSenderId: "101625695546",
  appId: "1:101625695546:web:152336e142eebb6fec9403",
  measurementId: "G-0L2GETHCH7"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export default App;
